import { getBooking } from "../../../app/api/getBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getAllOfferWithoutExchange, getAllTripWithoutExchange, getPassengerListByOfferAdmissions, getShuttleTripIds } from "../../../Lib/Utils/booking";
import { getUpperPassengerLabelByAge } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBookedOffer, IBooking, IBookingResponse, ISelectedPassenger } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IGetTicketAction } from "../../../Orchestrator/Types/Interface/EventParams/TicketAction";
import { BookingTypeTrip } from "../../../Orchestrator/Types/Types/BookingTypes";
import { isShuttleOffer } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";

class GetBookingDetailAction extends BaseAction<IDefaultActionResult, IGetTicketAction> {

    calculatePassengerListByPrice = async (booking: IBooking, screen: string = "", passengerSpecificationsTypes?: any) => {
        //Calculate passenger price        
        let allBookedOfferWithoutExchange: IBookedOffer[] = getAllOfferWithoutExchange(booking.bookedOffers)
        const allTripWithoutExchange: BookingTypeTrip[] = getAllTripWithoutExchange(allBookedOfferWithoutExchange, booking.trips)
        const trips = allTripWithoutExchange.filter(trip => {
            const shuttleTripIds = getShuttleTripIds(allBookedOfferWithoutExchange);
            return !(shuttleTripIds.includes(trip.id) && (trip.legs.length === trip.legs.filter(leg => leg.timedLeg.service.mode.ptMode === "BUS").length))
        });
        const shuttleTrips = allTripWithoutExchange.filter(trip => {
            const shuttleTripIds = getShuttleTripIds(allBookedOfferWithoutExchange);
            return shuttleTripIds.includes(trip.id);
        });

        const filteredOffers = allBookedOfferWithoutExchange.filter(
            offer => offer.products.length > 0 && !isShuttleOffer(offer)
        );
        allBookedOfferWithoutExchange = filteredOffers.length === 0 ? allBookedOfferWithoutExchange : filteredOffers;

        const outBoundPassengerPriceList: any = []
        const inBoundPassengerPriceList: any = []

        const updatedPassenger: ISelectedPassenger[] = booking.passengers.map((pass) => {
            const selectedPass: ISelectedPassenger = {
                email: pass?.detail?.email || "",
                firstName: pass?.detail?.lastName || "",
                id: pass.id,
                lastName: pass?.detail?.lastName || "",
                mobile: "",
                remember: pass.remember || false,
                age: pass.age,
                seatingDetails: null,
                cards: pass.cards || [],
                prmNeeds: pass.prmNeeds || [],
            }
            return selectedPass
        })
        const shuttleTripsOrTrips = trips.length === 0 ? shuttleTrips : trips
        const allPassenger = await getPassengerListByOfferAdmissions(updatedPassenger, shuttleTripsOrTrips, allBookedOfferWithoutExchange)

        allPassenger.outbound.forEach(pass => {
            const priceDetails = {
                pId: pass.id,
                pValue: pass.passengerPrice,
                pType: getUpperPassengerLabelByAge(pass.age || 0, pass),
                pStatus: pass.passengerStatus
            }
            outBoundPassengerPriceList.push(priceDetails)
        })
        allPassenger.inbound.forEach(pass => {
            const priceDetails = {
                pId: pass.id,
                pValue: pass.passengerPrice,
                pType: getUpperPassengerLabelByAge(pass.age || 0, pass),
                pStatus: pass.passengerStatus
            }
            inBoundPassengerPriceList.push(priceDetails)
        })
        updateRecoilState("allPassengerPriceAndAgeGroupAtom", outBoundPassengerPriceList)
        updateRecoilState("allPassengerPriceAndAgeGroupInBoundAtom", inBoundPassengerPriceList)

    }

    override async run(): Promise<IDefaultActionResult> {
        const actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            const { bookingId, screen } = this.params!;

            if (bookingId) {
                updateRecoilState("currentPassengerTicketAtom", 0);
                updateRecoilState("currentOfferIndexTicketAtom", 0);
                updateRecoilState("currentLegIndexTicketAtom", 0);
                const response: any = await getBooking(bookingId);
                if (response.status === 'ok' && response.answer) {
                    const bookingResponse: IBookingResponse = response.answer;
                    const { booking } = bookingResponse;
                    updateRecoilState('bookingResponseAtom', bookingResponse);
                    actionResult.data = bookingResponse
                    actionResult.status = "success"
                    await this.calculatePassengerListByPrice(booking, screen)
                } else {
                    console.warn("Failed to fetch Data.");
                }
            }
        } catch (error: any) {
            console.error("Error fetching Data:", error);
        } finally {
            return actionResult
        }
    }
}

export const getBookingDetailAction = new GetBookingDetailAction()